import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Toggle from 'react-toggle';
import { useTranslation } from 'react-i18next';

import { updatePartner, deletePartner, disablePartner, getCompanyById } from '../../../../../shared/api/action/CompaniesActions';

import { allCountriesOptions, statesOptions } from '../../helpers/constants';
import GreyHeader from '../../../../../shared/ui/GreyHeader';
import CustomButton from '../../CustomButton';

import '../../dump/menuComponents/menuComponents.sass';

const PartnerEditContainer = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'partnersPage.partnerEditContainer' });
    const { user, toggleLoader } = props;
    const userRole = user.roles[0];

    const [data, setData] = useState({
        company_name: '',
        company_city: '',
        company_state: '',
        company_zipcode: '',
        company_address: '',
        company_address2: '',
        company_country: '',
        company_phone_number: '',
        active: '',
        allow_create_company: false,
        allow_edit_company: false,
    })
    const [company, setCompany] = useState(null)
    const [modal, setModal] = useState({
        show: false,
        content: '',
        error: false
    })
    const [errMessage, setErrMessage] = useState({
        company_name: '',
        company_city: '',
        company_state: '',
        company_zipcode: '',
        company_address: '',
        company_country: '',
        active: '',
    })

    useEffect(() => {
        if (location.state.company) {
            getPartner(location.state.company.id);
        }
    }, [location.state])

    const getPartner = (partner_id) => {
        if (location) {
            toggleLoader(true);

            getCompanyById(userRole, partner_id)
                .then((res, err) => {
                    if (res.status == 200) {
                        toggleLoader(false);
                        let secondObject = {};
                        for (let k in res.data.response.company)
                            secondObject[k] = res.data.response.company[k];
                        let newElement = res.data.response.company;
                        setCompany(secondObject);
                        setData(newElement);

                    }
                    if (err) {
                        toggleLoader(false);
                        console.log(err);
                    }
                })
                .catch(error => {
                    toggleLoader(false);
                    console.log(error.response);
                });
        }
    }

    const cancel = () => {
        navigate('/partner');
    }

    const sendForm = (e) => {
        e.preventDefault();
    }

    const onSaveClick = (e) => {
        const requestData = {
            company: company,
            data: data
        }

        const error = checkForm(data);

        if (_.isEqual(company, data)) {
            toastr.warning('', t('partnerNoChanges'));
            return
        }

        if (!error) {
            toggleLoader(true);
            updatePartner(requestData, userRole)
                .then(res => {
                    if (company.active !== data.active) {
                        const active = data.active ? 'enable' : 'disable';

                        disablePartner(userRole, data, active)
                            .then(res => {
                                toggleLoader(false);
                            })
                            .catch((error) => {
                                toggleLoader(false);
                                toastr.error(t('unableDisablePartner'));
                            });
                    }
                    setCompany(data);
                    toggleLoader(false);
                    toastr.success("", t('updatedPartner'));
                })
                .catch((error) => {
                    toggleLoader(false);
                    let errDescription = i18n.t('errorMessage.errDescription');
                    if (error.response.data.response.error) {
                        errDescription = error.response.data.response.error
                    }
                    toastr.error(errDescription)
                });
        }
    }

    const checkForm = (data) => {
        let error = false;
        let updatedErrMessage = { ...errMessage };

        for (let i in data) {
            if (i === "company_name") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errNameRequired');
                } else if (!/^[a-zA-Z0-9 ]+$/.test(data[i])) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errNameSpecialCharacters');
                } else if (data[i].length < 3) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errNameMinLength');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_city") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errCityRequired');
                } else if (data[i].length < 3) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errCityMinLength');
                } else if (data[i].length > 50) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errCityMaxLength');
                } else if (!/^[a-zA-Z0-9 ]+$/.test(data[i])) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errCitySpecialCharacters');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_state" && data.company_country === "United States") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errStateRequired');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_state" && data.company_country !== "United States") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errStateRequired');
                } else if (!/^[a-zA-Z0-9 ]+$/.test(data[i])) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errStateSpecialCharacters');
                } else if (data[i].length < 2) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errStateMinLength');
                } else if (data[i].length > 50) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errStateMaxLength');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_zipcode") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errZIPrequired');
                } else if (!/^[a-zA-Z0-9 ]+$/.test(data[i])) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errZIPSpecialCharacters');
                } else if (data[i].length < 3) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errZIPMinLength');
                } else if (data[i].length > 20) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errZIPMaxLength');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_address") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errAddressRequired');
                } else if (data[i].length < 3) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errAddressMinLength');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_address2" && data[i] != '') {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errAddressRequired');
                } else if (data[i].length < 3) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errAddressMinLength');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_country") {
                if (data[i] === '') {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errCountryRequired');
                } else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
            if (i === "company_phone_number" && data[i] != '') {
                if (isNaN(data[i])) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errOnlyNumbers');
                } else if (data[i].length < 8) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errPhoneNumberLength');
                } else if (data[i].length > 15) {
                    error = true;
                    updatedErrMessage[i] = i18n.t('partnersPage.errCheckForm.errPhoneNumberTooLong');
                }
                else if (updatedErrMessage[i]) updatedErrMessage[i] = null;
            }
        }
        if (!updatedErrMessage['company_name'] && !/^[a-zA-Z0-9 \_\-\.]+$/.test(data.company_name)) {
            error = true;
            updatedErrMessage['company_name'] = i18n.t('partnersPage.errCheckForm.errPartnerNameFormat');
        }

        setErrMessage(updatedErrMessage);
        return error;
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : (name === 'company_phone_number') ? target.value.replace(/[^\d]/g, '') : target.value;
        const updatedData = { ...data };

        if (name === "company_country" && value !== "United States" && data.company_state) {
            updatedData.company_state = "";
        }

        setData({ ...updatedData, [name]: value });
    }

    const deletePartnerConfirm = () => {
        setModal({
            ...modal,
            show: true,
            content: `${t('deletePartnerContent')} ${location.state.company.company_name}?`
        });
    }

    const closeModal = () => {
        setModal({
            ...modal,
            error: false,
            show: false
        });
    }

    const deletePartnerModal = () => {
        const data = {
            partner_name: company.company_name,
            user_role: userRole
        }

        deletePartner(data)
            .then(res => {
                setModal({ ...modal, show: false });
                toastr.success("", t('partnerDeleted'));
                props.delPartner(data.partner_name);
                navigate('/partner');
            })
            .catch((error) => {
                setModal({ ...modal, show: false });

                toastr.error(i18n.t('errorMessage.errDescription'));
            });
    }

    const { company_name, company_city, company_state, company_zipcode, company_address, company_address2, company_country, company_phone_number } = errMessage;

    if (!company) {
        return (
            <GreyHeader title={t('titleEditPartner')} hideSubtitle />
        )
    }

    return (
        <>
            <GreyHeader title={t('titleEditPartner')} subtitle={data.company_name} />

            <div className='page-subheader'>
                <div className={classnames('subheader-section search-flex', { 'has-error': company_name })}>
                    <label className="search-label">{t('labelName')}</label>
                    <input type="text" name="company_name" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_name} />
                    {company_name && <span className="help-block">{company_name}</span>}
                </div>
                <div className='subheader-section'>
                    <CustomButton variant="secondary" onClick={onSaveClick}>{t('btnSave')}</CustomButton>
                    <CustomButton variant="secondary-outline" onClick={cancel}>{t('btnBack')}</CustomButton>
                    <CustomButton variant="delete" onClick={deletePartnerConfirm}>{t('btnDelete')}</CustomButton>
                </div>
            </div>
            <main className="main-content-block">
                <section>
                    <h3 className='category-title'>{t('titlePartnerInfo')}</h3>
                    <form onSubmit={sendForm}>
                        <div className='two-column-grid with-margin'>
                            <div className={classnames({ 'has-error': company_city })}>
                                <label className="control-label">{t('labelCity')}</label>
                                <input type="text" name="company_city" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_city} maxLength={50} />
                                {company_city && <span className="help-block">{company_city}</span>}
                            </div>

                            <div className={classnames({ 'has-error': company_state })}>
                                <label className="control-label">{t('labelState')}</label>
                                {data.company_country === "United States" ?
                                    <select
                                        placeholder="select"
                                        className="rosco-select block"
                                        name="company_state"
                                        onChange={handleInputChange}
                                        value={data.company_state}
                                    >
                                        {!statesOptions.includes(data.company_state) && <option value={data.company_state}>{data.company_state}</option>}
                                        {statesOptions.map(value => (
                                            <option value={value}>{value}</option>
                                        ))}
                                    </select> :
                                    <input type="text" name="company_state" className="vehicle-search" onChange={handleInputChange} value={data.company_state || ""} />}
                                {company_state && <span className="help-block">{company_state}</span>}
                            </div>

                            <div className={classnames({ 'has-error': company_zipcode })}>
                                <label className="control-label">{t('labelZipCode')}</label>
                                <input type="text" name="company_zipcode" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_zipcode} />
                                {company_zipcode && <span className="help-block">{company_zipcode}</span>}
                            </div>

                            <div className={classnames({ 'has-error': company_country })}>
                                <label className="control-label">{t('labelCountry')}</label>
                                <select
                                    placeholder="select"
                                    className="rosco-select block"
                                    name="company_country"
                                    onChange={handleInputChange}
                                    value={data.company_country}
                                >
                                    {!allCountriesOptions.includes(data.company_country) && <option value={data.company_country}>{data.company_country}</option>}
                                    {allCountriesOptions.map(value => (
                                        <option value={value}>{value}</option>
                                    ))}
                                </select>
                                {company_country && <span className="help-block">{company_country}</span>}
                            </div>

                            <div className={classnames({ 'has-error': company_address })}>
                                <label className="control-label">{t('labelAddress')}</label>
                                <input type="text" name="company_address" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_address} />
                                {company_address && <span className="help-block">{company_address}</span>}
                            </div>

                            <div className={classnames('optional', { 'has-error': company_address2 })}>
                                <label className="control-label">{t('labelAddress2')}<span>{t('optional')}</span></label>
                                <input type="text" name="company_address2" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_address2} />
                                {company_address2 && <span className="help-block">{company_address2}</span>}
                            </div>

                            <div className={classnames('optional', { 'has-error': company_phone_number })}>
                                <label className="control-label">{t('labelPhoneNumber')}<span>{t('optional')}</span></label>
                                <input type="text" name="company_phone_number" className="vehicle-search" onChange={(e) => { handleInputChange(e) }} value={data.company_phone_number} />
                                {company_phone_number && <span className="help-block">{company_phone_number}</span>}
                            </div>

                            <div>
                                <div>
                                    <label htmlFor="active" className="control-label">{t('enable/DisablePartner')}</label>
                                </div>
                                <label>
                                    <span className="toggle-left-title">{t('disable')}</span>
                                    <Toggle
                                        name="active"
                                        checked={data.active ? data.active : false}
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                    <span>{t('enable')}</span>
                                </label>
                            </div>
                        </div>
                    </form>
                </section>
                <section>
                    <h3 className="category-title">{t('titleAdminOptions')}</h3>
                    {(userRole === 'system_admin') &&
                        (<div className="two-column-grid with-margin" style={{ paddingBottom: '30px' }}>
                            <div>
                                <div>
                                    <label htmlFor="active" className="control-label">{t('labelAllowCreateCompany')}</label>
                                </div>
                                <label>
                                    <span className="toggle-left-title">{t('disable')}</span>
                                    <Toggle
                                        name="allow_create_company"
                                        checked={data.allow_create_company ? data.allow_create_company : false}
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                    <span>{t('enable')}</span>
                                </label>
                            </div>
                            <div>
                                <div>
                                    <label htmlFor="active" className="control-label">{t('labelAllowEditCompanies')}</label>
                                </div>
                                <label>
                                    <span className="toggle-left-title">{t('disable')}</span>
                                    <Toggle
                                        name="allow_edit_company"
                                        checked={data.allow_edit_company ? data.allow_edit_company : false}
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                    <span>{t('enable')}</span>
                                </label>
                            </div>
                        </div>)}
                    <div className="two-column-grid with-margin">
                        <CustomButton
                            variant="primary-outline"
                            id="sm"
                            onClick={() => navigate('/partner/whitelabel', {
                                state: { partnerId: company.id, partnerName: company.company_name },
                            })}
                        >
                            {t('btnWhitelabelSettings')}
                        </CustomButton>
                    </div>
                </section>
            </main>

            <Modal
                show={modal.show}
                onHide={closeModal}
                dialogClassName='has-error'
                className="modal-lg-size">
                <Modal.Header closeButton>
                    <Modal.Title className='delete-title'>{t('titleDeletePartner')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center modal-text'>{modal.content}</div>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton variant="delete" onClick={deletePartnerModal}>{t('btnDeletePartner')}</CustomButton>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default connect(
    state => ({
        user: state.user.user
    }),
    dispatch => ({
        delPartner: (partner) => {
            dispatch({ type: 'DEL_PARTNER_SUCCESS', payload: partner });
        },
        toggleLoader: (show) => {
            dispatch({ type: 'TOGGLE_LOADER', payload: show });
        }
    })
)(PartnerEditContainer);
